import {DialogTypes} from 'common/names';
import Dialog from 'components/Dialog';
import React, {memo} from 'react';
import SFTPServerSettingsPanel from '.';

interface Props {
   onClose: () => void;
}
const SFTPServerSettingsDialog = memo(({onClose}: Props) => {
   return (
      <Dialog maxWidth="xl" header={DialogTypes.SFTPServerSettings.dialogName} close={onClose}>
         <SFTPServerSettingsPanel onClose={onClose} />
      </Dialog>
   );
});

export default SFTPServerSettingsDialog;
